/**
 * 白名单
 * 在白名单内的请求不需要携带 token
 */

const whiteList: string[] = ['/login', '/refresh_token', '/passkey/login/options', '/passkey/login'];

// 判断是否必须携带 token
export const isRequireAddToken = (url: string = ''): boolean =>
  !whiteList.some((item) => url === item);
